const HeroBanner = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.prevButton = this.querySelector('[data-hero-banner-prev]');
    this.nextButton = this.querySelector('[data-hero-banner-next]');
    this.pagination = this.querySelector('[data-hero-banner-pagination]');

    this.initHeroBanner();
  }

  initHeroBanner() {
    if (!this.classList.contains('swiper')) { return; }

    const options = {
      slidesPerView: 1,
      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton
      },
      pagination: {
        el: this.pagination,
        type: 'bullets',
        clickable: true,
        bulletClass: 'hero-banner-carousel-pagination__bullet'
      }
    }
    const swiper = new Swiper(this, options);

    return swiper;
  }
};

if (typeof window.customElements.get('hero-banner') === 'undefined') {
  window.customElements.define('hero-banner', HeroBanner);
}
